import React from 'react'

import {SapiClient} from '@findhotel/sapi'

export const SapiContext = React.createContext(
  null
) as React.Context<null | SapiClient>

export const SapiProvider = SapiContext.Provider
